import React from 'react';
import ScrollBar from 'react-custom-scrollbars';
import { getPresentationAttendees } from '../commonUtil/presentationUtil';

const AttendeesList = ({ brandingHilightColor }) => {
    const attendees = getPresentationAttendees();
    if (attendees && attendees.split(';').length > 0) {
        const attendeeItems = attendees.split(';').map(attendee =>
            (attendee && <div key={attendee} className="livesend-viewer-recipient-chip attendee-item">
                <div className="recipient-icon">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.35981 0.0600586H1.6398C1.1778 0.0600586 0.799805 0.438058 0.799805 0.900058V4.96006C0.799805 5.42206 1.1778 5.80006 1.6398 5.80006H8.35981C8.82181 5.80006 9.19981 5.42206 9.19981 4.96006V0.900058C9.19981 0.438058 8.82181 0.0600586 8.35981 0.0600586ZM4.80381 4.82006H2.39581C2.1298 4.82006 1.9198 4.52606 1.9198 4.24606C1.9338 3.82606 2.36781 3.57406 2.82981 3.36406C3.15181 3.22406 3.1938 3.09806 3.1938 2.95806C3.1938 2.81806 3.10981 2.69206 2.99781 2.59406C2.81581 2.42606 2.7038 2.17406 2.7038 1.89406C2.7038 1.36206 3.02581 0.914058 3.58581 0.914058C4.14581 0.914058 4.46781 1.36206 4.46781 1.89406C4.46781 2.17406 4.36981 2.42606 4.17381 2.59406C4.06181 2.69206 3.97781 2.81806 3.97781 2.95806C3.97781 3.09806 4.01981 3.22406 4.34181 3.35006C4.80381 3.54606 5.23781 3.82606 5.25181 4.24606C5.27981 4.52606 5.06981 4.82006 4.80381 4.82006ZM8.07981 3.84006C8.07981 3.99406 7.95381 4.12006 7.79981 4.12006H6.53981C6.38581 4.12006 6.25981 3.99406 6.25981 3.84006V3.42006C6.25981 3.26606 6.38581 3.14006 6.53981 3.14006H7.79981C7.95381 3.14006 8.07981 3.26606 8.07981 3.42006V3.84006ZM8.07981 2.30006C8.07981 2.45406 7.95381 2.58006 7.79981 2.58006H5.69981C5.54581 2.58006 5.41981 2.45406 5.41981 2.30006V1.88006C5.41981 1.72606 5.54581 1.60006 5.69981 1.60006H7.79981C7.95381 1.60006 8.07981 1.72606 8.07981 1.88006V2.30006Z" fill="white" />
                    </svg>
                </div>
                <div className="recipient-label">
                    {attendee}
                </div>
            </div>));
        return (<div className="livesend-viewer-attendee-container">
            <span className="attendee-title" style={{ color: brandingHilightColor }}>Attendees</span>
            <div className="attendee-list">
                <ScrollBar autoHide
                    autoHeight
                    autoHeightMax={200}
                    renderView={scrollProps => <div {...scrollProps} className="attendee-list-scroll-box" />}>
                    {attendeeItems}
                </ScrollBar>
            </div>
        </div>);
    }

    return null;
};

export default AttendeesList;
